import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as s, createElementVNode as d } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconAgentAssist",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ d("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9 0a.5.5 0 0 1 .5.5V1h.5a.5.5 0 1 1 0 1h-.5v.5a.5.5 0 1 1-1 0V2H8a.5.5 0 0 1 0-1h.5V.5A.5.5 0 0 1 9 0ZM2.5 2a.5.5 0 0 0-.5.5v7.614l1.492-.9a.5.5 0 0 1 .258-.071H9.5a.5.5 0 0 0 .5-.5V6.929a.5.5 0 0 1 1 0v1.714a1.5 1.5 0 0 1-1.5 1.5H3.89l-2.132 1.285A.5.5 0 0 1 1 11V2.5A1.5 1.5 0 0 1 2.5 1h3.95a.5.5 0 1 1 0 1H2.5ZM6 3a.5.5 0 0 1 .455.293l.548 1.204 1.204.548a.5.5 0 0 1 0 .91l-1.204.548-.548 1.204a.5.5 0 0 1-.91 0l-.547-1.204-1.205-.548a.5.5 0 0 1 0-.91l1.205-.548.547-1.204A.5.5 0 0 1 6 3Zm4.5 0a.5.5 0 0 1 .5.5V4h.5a.5.5 0 1 1 0 1H11v.5a.5.5 0 1 1-1 0V5h-.5a.5.5 0 0 1 0-1h.5v-.5a.5.5 0 0 1 .5-.5ZM6 4.708l-.17.374a.5.5 0 0 1-.248.248l-.373.17.373.17a.5.5 0 0 1 .248.248l.17.374.17-.374a.5.5 0 0 1 .248-.248l.374-.17-.374-.17a.5.5 0 0 1-.248-.248L6 4.708Z",
  fill: "currentColor"
}, null, -1), h = [
  _
];
function m(e, u, i, f, p, a) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: s([a.iconSizeClass, "d-icon d-icon--agent-assist"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Agent Assist",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const V = /* @__PURE__ */ n(o, [["render", m]]);
export {
  V as default
};
//# sourceMappingURL=agent-assist.js.map
